import { render, staticRenderFns } from "./theme_collection.vue?vue&type=template&id=da5be828&scoped=true&"
import script from "./theme_collection.vue?vue&type=script&lang=js&"
export * from "./theme_collection.vue?vue&type=script&lang=js&"
import style0 from "./theme_collection.vue?vue&type=style&index=0&id=da5be828&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5be828",
  null
  
)

export default component.exports